// Per-process threat chip (RESTYLE §2): MAL · SUS · INFO, tinted, at the start of a process-tree row when a tag cites it.
//   <ThreatChip level? sev? title? className? />   level wins; otherwise sev maps through threatLevel()
//   threatLevel(sev) → "mal" (high, critical) | "sus" (medium) | "info" (low, info)
import type { SevLevel } from "./Glyphs";
import { cx } from "./cx";

type ThreatLevel = "mal" | "sus" | "info";

const WORD: Record<ThreatLevel, string> = { mal: "malicious activity", sus: "suspicious activity", info: "informational" };

export function threatLevel(sev: SevLevel): ThreatLevel {
  return sev >= 4 ? "mal" : sev === 3 ? "sus" : "info";
}

export function ThreatChip({ level, sev, title, className }: { level?: ThreatLevel; sev?: SevLevel; title?: string; className?: string }) {
  const l = level ?? (sev ? threatLevel(sev) : "info");
  return (
    <span className={cx("tchip", `tchip--${l}`, className)} title={title ?? WORD[l]}>
      <span aria-hidden="true">{l}</span>
      <span className="sr-only">{WORD[l]}</span>
    </span>
  );
}
